export default {
    accountInfo: 'اطلاعات حساب کاربری',
    adult: 'بزرگسال',
    adultCount: '{0} بزرگسال',
    airline: 'هواپیمایی',
    airlineDisplayName: 'هواپیمایی {0}',
    applicant: 'درخواست دهنده',
    back: 'برگشت',
    birthDate: 'تاریخ تولد',
    bookingSiteRank: 'کیفیت {0} از نگاه ',
    bookingSiteRankMobile: '{0} از نگاه ',
    bus: 'اتوبوس',
    callCenterPhoneNumber: '۰۲۱ - ۴۳۹۰۰۰۰۰',
    callCenterPhoneNumber2: '۰۲۱ - ۴۹۲۷۵۰۰۰',
    cancelFilters: 'لغو فیلترها',
    cellPhone: 'تلفن همراه',
    cellPhoneNember: 'شماره تلفن همراه',
    change: 'تغییر {0}',
    changePassword: 'تغییر رمز عبور',
    chargeBalance: 'افزایش اعتبار',
    charter: 'چارتری',
    child: 'کودک',
    childCount: '{0} کودک',
    choose: 'انتخاب',
    close: 'بستن',
    confirmBackStepText: 'توجه فرمائید: در صورتی که اطلاعات زیر را اشتباه وارد نموده‌اید و یا نیاز به تغییر آن دارید، میتوانید از دکمه بازگشت استفاده کنید.',
    confirmInformations: 'لطفا اطلاعات وارد شده را کنترل کرده و پس از اطمینان از درستی آنها، برای پرداخت هزینه اقدام نمایید.',
    confirmPassword: 'تکرار رمز عبور',
    continue: 'ادامه',
    currencyT: 'تومان',
    currentCurrency: 'ریال',
    date: 'تاریخ',
    day: 'روز',
    departing: 'رفت',
    departingDate: 'تاریخ رفت',
    departingFlight: 'پرواز رفت',
    destination: 'مقصد',
    discount: 'تخفیف',
    displayAll: 'مشاهده همه',
    displayOnMap: 'نمایش روی نقشه',
    domesticAndInternational: 'داخلی‌وخارجی',
    domesticFlight: 'پرواز داخلی',
    downloadApp: 'دانلود اپلیکیشن علی‌بابا',
    downloadAndroidApp: 'دانلود اپلیکیشن اندروید علی‌بابا',
    downloadIOSApp: 'دانلود اپلیکیشن iOS علی‌بابا',
    downloadAppFromGooglePlay: 'دانلود اپلیکیشن علی‌بابا از Google Play',
    // downloadAppFromSibApp: 'دانلود اپلیکیشن علی بابا از سیب اپ',
    downloadAppFromIApps: 'دریافت از آی اپس',
    email: 'ایمیل',
    exit: 'خروج از حساب کاربری',
    faq: 'سؤالات متداول',
    female: 'زن',
    firstName: 'نام',
    flight: 'پرواز',
    flightDisplayName: 'پرواز {0} {1}',
    from: 'از',
    gender: 'جنسیت',
    gregorian: 'میلادی',
    highestPrice: 'بیشترین قیمت',
    highlyVisitedProducts: 'پر بازدید',
    highTrafficCities: 'شهرهای پر تردد',
    hotel: 'هتل',
    hotelDesktop: 'هتل خارجی و داخلی',
    hotelFacilities: 'امکانات هتل',
    hotelDisplayName: 'هتل {0}',
    hotelDisplayStar: 'هتل {0} ستاره',
    hotelDetail: 'اطلاعات هتل',
    hour: 'ساعت',
    installPWAApp: 'نصب نسخه وب‌اپلیکیشن',
    internationalFlight: 'پرواز خارجی',
    internationalHotels: 'هتل',
    jabama: 'جاباما',
    knowMore: 'بیشتر بدانید',
    lastName: 'نام خانوادگی',
    login: 'ورود',
    loginWebsite: 'ورود به سایت',
    lowestPrice: 'کمترین قیمت',
    loyalty: {
        voucherUsageTill: 'تاریخ استفاده تا',
        neededScore: 'امتیاز مورد نیاز',
    },
    male: 'مرد',
    minute: 'دقیقه',
    mobileNumber: 'شماره موبایل',
    mobilePhoneNumber: 'شماره همراه',
    month: 'ماه',
    more: 'بیشتر',
    nextStep: 'مرحله بعد',
    nightsCount: '{0} شب',
    no: 'خیر',
    notRefundable: 'غیرقابل استرداد',
    number: 'عدد',
    oneWay: 'یک طرفه',
    onlinePayment: 'پرداخت آنلاین',
    origin: 'مبدا',
    otpLogin: 'ورود با رمز موقت',
    passengerList: 'لیست مسافران',
    passengers: 'مسافران',
    passengersRevision: 'اصلاح مسافران',
    passportNumber: 'شماره پاسپورت',
    payableAmount: 'مبلغ قابل پرداخت',
    payFromBalance: 'پرداخت از موجودی حساب',
    paymentConfirm: 'تایید پرداخت',
    password: 'رمز عبور',
    path: 'مسیر',
    person: 'نفر',
    photoGallery: 'گالری تصاویر',
    plane: 'هواپیما',
    point: 'امتیاز',
    policy: 'قوانین و مقررات',
    price: '{0} @:common.currentCurrency',
    pricesOfPlaneTickets: 'قیمت بلیط هواپیما',
    purchaseGuide: 'راهنمای خرید',
    purchaseGuideDisplayName: 'راهنمای خرید {0}',
    quality: 'کیفیت {0}',
    readMore: 'بیشتر بخوانید',
    required: '{0} (الزامی)',
    reserve: 'رزرو',
    resetPassword: 'بازیابی رمز عبور',
    return: 'بازگشت',
    returning: 'برگشت',
    returningDate: 'تاریخ برگشت',
    returningFlight: 'پرواز برگشت',
    returnToPrev: {
        path: '{0} {1}',
        child1: 'بازگشت به',
        child2: 'مرحله قبل',
    },
    room: 'اتاق',
    roomCount: '{0} اتاق',
    rulesAcceptance: 'پذیرفتن قوانین',
    score: 'امتیاز',
    search: 'جستجو',
    searchAgain: 'جستجوی مجدد',
    searchHotel: 'جستجوی هتل',
    searchResult: 'نتیجه جست‌وجو',
    sendAgain: 'ارسال مجدد کد تایید',
    sendAgainTimer: 'فعال شدن ارسال مجدد کد تایید بعد از {0} ثانیه',
    signInByGoogle: 'ثبت نام با حساب گوگل',
    signUp: 'ثبت نام',
    signUpAsNew: 'ثبت نام حساب کاربری جدید',
    specialOffer: 'پیشنهاد ویژه',
    star: 'ستاره',
    startingPriceAt: 'شروع قیمت از',
    submit: 'ثبت',
    ticket: 'بلیط',
    ticketDisplayName: 'بلیط {0}',
    ticketInfo: 'اطلاعات بلیط',
    to: 'تا',
    totalPrice: 'مجموع قیمت',
    tour: 'تور',
    tourDisplayName: 'تور {0}',
    tours: 'تور ها',
    train: 'قطار',
    trainDisplayName: 'قطار {0}',
    trainTicketCityToCity: 'بلیط قطار {0} {1}',
    transport: 'حمل و نقل',
    twoWay: 'رفت و برگشت',
    userAccount: 'حساب کاربری',
    userBalance: 'موجودی حساب',
    userFullName: 'نام کاربر',
    verify: 'تایید',
    view: 'مشاهده',
    viewAndBook: 'مشاهده و رزرو',
    websiteColleagues: 'همکاران علی‌بابا',
    websiteName: 'علی‌بابا',
    websiteSlogan: 'نزدیک‌ترین شعبه‌ی علی‌بابا در جیب شماست',
    wholePrice: 'قیمت کل',
    year: 'سال',
    yes: 'بله',
    confirm: 'تایید',
    searchOriginToDestination: 'جستجوی {origin} به {destination}',
};
